import type { TemplateUsage as TemplateType } from '@bb/domain/dist/types/Template';

// Tag replacement
export const TEMPLATE_TAG_LABELS = {
  coopFirstName: 'Showing Agent First Name',
  coopLastName: 'Showing Agent Last Name',
  appointmentDate: 'Showing Date',
  appointmentTime: 'Showing Time',
  totalOffers: 'Total # of Offers',
  feedbackLink: 'Feedback Button Link',
  registerOfferLink: 'Register Offer Link',
  listingThumbnailLink: 'Listing Thumbnail Image',
  listingAddress: 'Listing Address',
  viewListingLink: 'View Listing Button Link',
  bookAppointmentLink: 'Book Showing Button Link',
  listingBrokerageName: 'Listing Brokerage Name',
  listingBrokeragePhone: 'Listing Brokerage Phone',
  listingAgentFirstName: 'Listing Agent First Name',
  listingAgentLastName: 'Listing Agent Last Name',
  listingAgentEmail: 'Listing Agent Email',
  listingAgentMobile: 'Listing Agent Mobile',
  sellerFirstName: 'Seller First Name',
  sellerLastName: 'Seller Last Name',
} as const;

export type TagType = keyof typeof TEMPLATE_TAG_LABELS;

export const TEMPLATE_TAG_TYPES = Object.keys(TEMPLATE_TAG_LABELS) as TagType[];

export const convertTagToHtml = (tag: TagType) =>
  `<span class="template-tag fr-deletable" contenteditable="false" draggable="true" data-type="${tag}">${TEMPLATE_TAG_LABELS[tag]}</span>`;

export const replaceTagsWithMarkup = (text: string) => {
  const re = /{{(\w+)}}/g;

  return text.replace(re, (match, p1) => convertTagToHtml(p1));
};

export const replaceMarkupWithTags = (text: string) => {
  const re = /<span [^>]*?data-type="(\w+).*?">(?:(?!>).)*<\/span>/g;
  const sub = `{{$1}}`;

  return text.replace(re, sub);
};

// Default templates
export const defaultTemplates: Record<
  Exclude<TemplateType, 'emailSignature'>,
  { subject?: string; body: string; name?: string }
> = {
  offer: {
    body: '<p>Please be advised that an offer has been registered on {{listingAddress}}.</p><p>TOTAL # OFFERS: {{totalOffers}}.</p><p><br>For more information, please contact the listing agents.</p><p>{{registerOfferLink}}&nbsp;</p><br>',
    name: 'Default Offer Registration template',
  },
  propertyAnnouncement: {
    body: '<p></p>',
    name: 'Default Message Showing Agents template',
  },
  sendListing: {
    subject: '',
    body: '<p></p>',
  },
  feedback: {
    body: '<p>Hi {{coopFirstName}},</p><p><br>Thank you for showing {{listingAddress}} on {{appointmentDate}}.</p><p>I would truly appreciate if you could provide feedback when you have a moment.</p><p><br>Please find a quick survey in the link below.</p><p>{{feedbackLink}}</p><br><p>Regards,</p><br>',
    name: 'Default Feedback template',
  },
  feedbackSurvey: {
    body: JSON.stringify([
      {
        type: 'radio',
        label: 'Is your client interested?',
        options: ['Yes', 'Maybe', 'No'],
      },
      {
        type: 'radio',
        label: 'How do you feel about the price?',
        options: ['High', 'Good', 'Low'],
      },
      {
        type: 'radio',
        label: 'Are you bringing an offer?',
        options: ['Yes', 'Maybe', 'No'],
      },
      { type: 'text', label: 'Additional Comments:' },
    ]),
    name: 'Default Feedback Survey template',
  },
};

export interface ComposeDefaultEmailSignatureOptions {
  brokerageName: string;
  agentName: string;
  officeNumber: string;
  mobileNumber?: string;
  email: string;
}
export const composeDefaultEmailSignature = (
  options: ComposeDefaultEmailSignatureOptions,
) => {
  const { brokerageName, agentName, officeNumber, mobileNumber, email } =
    options;
  const body = `<p>${agentName}</p><p>${brokerageName}</p><p>Office: ${
    officeNumber || '-'
  }<br>${
    // Mobile might not be released
    mobileNumber ? `Mobile: ${mobileNumber}<br>` : ''
  }Email: ${email}</p>`;

  return {
    name: 'Default Email Signature template',
    body,
  };
};
